import { PostgresTileCatalogServiceConfigurationDc } from "@evergis/api";
import React, { FC } from "react";
import { useDialogShadow } from "@evergis/ui";

import { DialogActions } from "../../DialogComponents/DialogActions";
import { DialogTitle } from "../../DialogComponents/DialogTitle";
import { FullScreenDialog } from "../../DialogComponents/FullScreenDialog";
import { UploadMaxZoomLevel } from "./UploadMaxZoomLevel";
import { UploadWizard } from "./UploadWizard";
import { UploadAttributesList } from "./UploadAttributesList";
import { DialogContent, RestrictedWidthContainer } from "../../DialogComponents/styled";
import { useUploadDataContext } from "../uploadDataContext";
import { useDialogInfo } from "../../../../hooks/useDialogs";
import { useLayerAttributesFromLayer, usePostgresLayer } from "../../../../hooks/layer/usePostgresLayer";
import { useContext } from "../hooks/useContext";

export const UploadAttributes: FC = () => {
  const context = useContext();
  const { nextText, nextStep, prevStep } = useUploadDataContext();
  const { shadows, setScrollContainer } = useDialogShadow();
  const { resources } = useDialogInfo();
  const { postgresLayer, loading } = usePostgresLayer(resources[0], { waitInput: true });
  const attributes = useLayerAttributesFromLayer(postgresLayer, true);

  return (
    <FullScreenDialog dialogContext={context}>
      <DialogTitle displayShadow={shadows.upper} />
      <DialogContent ref={setScrollContainer}>
        <RestrictedWidthContainer>
          <UploadWizard />
          {!loading && !(postgresLayer?.configuration as PostgresTileCatalogServiceConfigurationDc)?.isCogLayer && (
            <UploadMaxZoomLevel />
          )}
        </RestrictedWidthContainer>
        <UploadAttributesList />
      </DialogContent>
      <DialogActions
        displayShadow={shadows.bottom}
        applyDisabled={!Object.keys(attributes).length}
        applyText={nextText}
        onApply={nextStep}
        onBackButton={prevStep}
      />
    </FullScreenDialog>
  );
};
